enum Roles {
  ClusterManager = "cluster_manager",
  ClusterAdmin = "cluster_admin",
  TribeManager = "trybe_manager",
  TribeAdmin = "trybe_admin",
  EstateAdmin = "estate_admin",
  EstateManager = "estate_manager",
  Admin = "admin",
}

export default Roles;
